import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M23 3H1v16h7v2h8v-2h6.99L23 3zm-2 14H3V5h18v12zm-5-6l-7 4V7l7 4z"
}), 'OndemandVideoSharp');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/OndemandVideoSharp.js
// module id = 5134
// module chunks = 2